var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNavClass = function SvgNavClass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.022 10.945a3.611 3.611 0 0 1 3.607 3.607v1.794a3.612 3.612 0 0 1-3.607 3.608h-1.794a3.612 3.612 0 0 1-3.607-3.608v-1.794a3.611 3.611 0 0 1 3.607-3.607h1.794Zm-10.621 0a3.611 3.611 0 0 1 3.607 3.607v1.794a3.612 3.612 0 0 1-3.607 3.608H3.607A3.612 3.612 0 0 1 0 16.346v-1.794a3.611 3.611 0 0 1 3.607-3.607h1.794ZM15.125.178c.964 0 1.87.376 2.551 1.057l1.268 1.268A3.585 3.585 0 0 1 20 5.054a3.58 3.58 0 0 1-1.056 2.55l-1.268 1.27a3.585 3.585 0 0 1-2.551 1.056c-.963 0-1.87-.375-2.55-1.056l-1.269-1.27a3.584 3.584 0 0 1-1.057-2.55c0-.963.376-1.869 1.057-2.55l1.268-1.269a3.585 3.585 0 0 1 2.55-1.057ZM5.4.55a3.611 3.611 0 0 1 3.607 3.608V5.95A3.611 3.611 0 0 1 5.4 9.557H3.607A3.611 3.611 0 0 1 0 5.951V4.158A3.611 3.611 0 0 1 3.607.55h1.794Z",
    fill: "var(--primaryColor)"
  })));
};

export default SvgNavClass;